import React, { useEffect, useState } from 'react'
import { Get_Api } from '../API_URL';

function PrivacyPolicy() {
    const [privacypolicy, setprivacypolicy] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const Getprivacypolicy = async () => {
        try {
            setIsLoading(true);
            const response = await Get_Api("api/admin/Getprivacypolicy");
            setprivacypolicy(response?.data?.PrivacyPolicy);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        Getprivacypolicy();
    }, []);

    return (
        <>
            <section className="relative overflow-hidden lg:mt-[72px] mt-[66px]">
                <img
                    src="/assets/our/bg2.png"
                    className="h-[200px] sm:h-[250px] md:h-[300px] w-full object-cover"
                    alt=""
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center px-4">
                    <h2 className="font-neue text-[26px] sm:text-[32px] md:text-[40px] text-white">
                        Privacy Policy
                    </h2>
                </div>
            </section>
            <section className="max-w-[900px] mx-auto px-4 py-10">
                {isLoading ? (
                    <p className="text-center text-gray-600">Loading...</p>
                ) : (
                    <div
                        className="blog-content prose prose-lg max-w-none font-neue text-[#333]"
                        dangerouslySetInnerHTML={{ __html: privacypolicy }}
                    />
                )}
            </section>
        </>
    );
}

export default PrivacyPolicy;
